import moment from 'moment';

type EventItem = {
    customData?: {
        title: string;
    };
    dates?: {
        start: string;
        end: string;
    };
}

export const eventTitle = ({ customData, dates }: EventItem , currentDay?: number) => {
    if (!customData) {
        return '';
    }
    if (!dates?.start || !dates?.end || !currentDay) {
        return customData.title;
    }
    const dateStart = moment(dates.start);
    const dateEnd = moment(dates.end);
    if (dateStart.isSame(dateEnd, 'day') || dateStart.date() !== currentDay || !dateStart.hours()) {
        return customData.title;
    }
    return `${dateStart.format('HH:mm')}&nbsp;${customData.title}`;
};
